_isFinite2